import { LoadingOutlined } from "@ant-design/icons";
import { Col, Empty, Row, Spin, Tag, Typography } from "antd";
import React from "react";
import SupporterAction from "./supporter_action";
import SupporterTable from "./supporter_table";
import { useSupporterRefine } from "hook/supporters/useSupporter";
import { useResponsive } from "hook/useResponsive";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const SupporterLists = () => {
  // -------------------------- VAR -----------------------------
  const data = useSupporterRefine();
  const { mobile } = useResponsive();
  const align = mobile ? "center" : "left";
  const alignAction = mobile ? "center" : "right";
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const supporters = data;
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderLoading = () => {
    if (supporters === null) {
      return (
        <div
          style={{
            width: "100%",
            minHeight: 200,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: 10,
            border: "0.5px solid rgba(0,0,0,0.1)",
          }}
        >
          <Spin indicator={<LoadingOutlined spin />} />
          <div>Đang tải danh sách</div>
        </div>
      );
    }
  };

  const renderEmpty = () => {
    if (supporters?.length === 0) {
      return (
        <div
          style={{
            width: "100%",
            minHeight: 200,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: 10,
            border: "0.5px solid rgba(0,0,0,0.1)",
          }}
        >
          <Empty description="Dữ liệu nhân viên trống" />
        </div>
      );
    }
  };

  const renderLists = () => {
    if (supporters?.length > 0) {
      return (
        <div
          style={{
            width: "100%",
            minHeight: 300,
            display: "flex",
            flexDirection: "column",
            gap: 10,
            border: "0.5px solid rgba(0,0,0,0.1)",
            padding: 10,
            borderRadius: 5,
          }}
        >
          <SupporterTable />
        </div>
      );
    }
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Row gutter={[10, 10]} style={{ padding: mobile ? "20px 5px" : 20 }}>
      <Col
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: align,
          gap: 10,
        }}
        xl={12}
        lg={12}
        md={12}
        xs={24}
      >
        <Typography.Title style={{ margin: 0 }} level={5}>
          Danh sách nhân viên{" "}
        </Typography.Title>
        <Tag style={{ borderRadius: 30 }}>
          {supporters?.length || 0} nhân viên
        </Tag>
      </Col>
      <Col align={alignAction} xl={12} lg={12} md={12} xs={24}>
        <SupporterAction />
      </Col>
      <Col xl={24} lg={24} md={24} xs={24}>
        {renderLists()}
        {renderEmpty()}
        {renderLoading()}
      </Col>
    </Row>
  );
};
export default SupporterLists;
